
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UserDto, UserPath } from '../Manipulate/UserDto';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class UserService {
  private apiUrl = environment.apiUrl +'/user';

  constructor(private http: HttpClient) { }

  public GetUser(): Observable<UserDto>{
    return this.http.get<UserDto>(`${this.apiUrl}/by-jwt`);
  }
  public AtualizarPreferencias(photo:FormData) : Observable<any>{
    return this.http.post(`${this.apiUrl}/update-user-preferences`, photo);
  }

}
